import { HTMLProps } from 'react'

import { TreeInformation } from 'react-complex-tree'

export function TreeItemsContainer({
  containerProps,
  children,
}: {
  children: React.ReactNode
  containerProps: HTMLProps<HTMLUListElement>
  info: TreeInformation
}) {
  return (
    <ul {...containerProps} className="flex flex-col">
      {children}
    </ul>
  )
}
